import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 * @desc get preview proration
 */
export function getProrationAction(newPriceId) {  
    let url = UrlConstants.getProrationUrl;
    url = url.replace("{newPriceId}",newPriceId);

    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {

         
          if(response.status == code.OK) {
              dispatch( {
                  type: types.GET_PRORATION,
                  proration: response.data
              });
          }
          else {
              dispatch({
                  type: types.GET_PRORATION,
                  proration: []
              });
          }
          return response;
      });
    }  
}

/**
 * @desc change subscription
 */
export function changeSubscriptionAction(data) {
    return function (dispatch){
        return APIUtil.postMethod(UrlConstants.changeSubscriptionurl, data, true).then(response => {
          if(response.status == code.OK) {
            dispatch( {
                type: types.CHANGE_SUBSCRIPTION,
                subscriptionData: response.data
            });
        }
        else {
            dispatch( {
                type: types.CHANGE_SUBSCRIPTION,
                subscriptionData: response.data
            });
        }
            return response;
        });
    }
}

/**
 * @desc re-activate plan
 */
export function reActivateSubscriptionAction() {  

    return function (dispatch){
      return APIUtil.getMethod(UrlConstants.reActivateSubscriptionUrl, true).then(response => {

         
          if(response.status == code.OK) {
              dispatch( {
                  type: types.REACTIVATE_PLAN,
                  reactivate: response.data
              });
          }
          else {
              dispatch({
                  type: types.REACTIVATE_PLAN,
                  reactivate: []
              });
          }
          return response;
      });
    }  
}

/**
 * @desc activate subscription
 */
export function activateSubscriptionAction(data) {
    return function (dispatch){
        return APIUtil.postMethod(UrlConstants.activateSubscriptionurl, data, true).then(response => {
          if(response.status == code.OK) {
            dispatch( {
                type: types.ACTIVATE_PLAN,
                activateData: response.data
            });
        }
        else {
            dispatch( {
                type: types.ACTIVATE_PLAN,
                activateData: response.data
            });
        }
            return response;
        });
    }
}